import { Button, HStack, Icon, Stack } from '@genial/components';
import React from 'react';

import { TableContent, TableContentItemColumn } from '../../../../../../../components/TableContent';
import {
  StatusSkeleton,
  TextSkeleton,
} from '../../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { tableHead } from '../constants';
import { LogoWithNameLoading } from '../TransferRequestsItem/components/LogoWithName';

export const SkeletonItemDesktop: React.FC = () => {
  const getFlex = (index: number) => {
    const currentHead = tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <Stack px="inline.xxxs">
      <TableContent direction="row">
        <TableContentItemColumn flex={getFlex(0)}>
          <HStack alignItems="center" justifyContent="space-between">
            <LogoWithNameLoading />
            <Icon name="ArrowRight" size="xs" color="neutral.light" />
          </HStack>
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(1)}>
          <LogoWithNameLoading />
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(2)}>
          <TextSkeleton />
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(3)}>
          <TextSkeleton />
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(4)}>
          <TextSkeleton />
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(5)}>
          <StatusSkeleton />
        </TableContentItemColumn>
        <TableContentItemColumn flex={getFlex(6)}>
          <Button
            variant="textLink"
            color="neutral.medium"
            isDisabled
            rightIcon={<Icon name="ChevronRight" size="xxs" color="neutral.medium" />}>
            VER DETALHES
          </Button>
        </TableContentItemColumn>
      </TableContent>
    </Stack>
  );
};
